import { toast } from 'sonner';

/**
 * shareFind2Day — single app-wide "Share Find-2-Day" action.
 *
 * Used by BOTH the Discover top-right Share button and the Settings
 * "Share Find-2-Day" row so there is only ONE implementation.
 *
 * Opens the device's native share sheet (Web Share API) where available
 * — WhatsApp, Messenger, SMS, Email, etc. — and gracefully falls back to
 * copying the link to the clipboard on browsers without Web Share.
 */
export async function shareFind2Day(t) {
  const tr = typeof t === 'function' ? t : (_k, d) => d;
  const url = (typeof window !== 'undefined' && window.location && window.location.origin)
    ? window.location.origin
    : 'https://find-2-day.com';
  const title = 'Find-2-Day';
  const text = tr('shareAppText', 'Find local businesses, events and offers near you on Find-2-Day.');

  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (err) {
      if (err && err.name === 'AbortError') return 'cancelled';
      // fall through to clipboard fallback
    }
  }

  const shareStr = `${text} ${url}`;
  try {
    await navigator.clipboard.writeText(shareStr);
  } catch {
    const ta = document.createElement('textarea');
    ta.value = shareStr;
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (_) { /* ignore */ }
    document.body.removeChild(ta);
  }
  toast.success(tr('linkCopied', 'Link copied!'));
  return 'copied';
}
